<template>
  <div>
    <div class="modal overflow-y-auto modal__overlap in show">
      <div :class="`modal__content modal__content--${size}`">
        <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
          <h2 class="font-medium text-base mr-auto">
            {{title}}
          </h2>
        </div>
        <slot />
      </div>
    </div>
    <div class="modal-backdrop in" @click="emitClose"></div>
  </div>
</template>

<script>
  export default {
    name: 'Modal',
    props: {
      title: {
        type: String,
        default: 'Modal',
      },
      size: {
        type: String,
        default: 'md',
      },
    },
    methods: {
      emitClose() {
        this.$emit('close')
      },
    }
  }
</script>

<style scoped>
  .modal__content {
    margin: 0px !important
  }
  .modal {
    z-index: 150;
    display: block;
    margin-top: 0px;
    margin-left: 0px;
    width: auto;
    height: auto;
    left: 50%;
    top: 10%;
    transform: translateX(-50%);
  }
  .modal-backdrop {
    z-index: 100;
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0,0,0,.65);
  }
</style>



// WEBPACK FOOTER //
// Modal.vue?abf49ff2